import React, {Fragment} from 'react';
import {translate} from "react-i18next";
import connect from "react-redux/es/connect/connect";
import {load} from "../../actions/logbookAction";
import moment from "moment";
import LogbookApi from "../../apis/LogbookApi";
import Comments from "./Comments";
import reactStringReplace from "react-string-replace";

class Information extends React.Component {

    state = {
        editing: false,
        loaded: false,
        startDelete: false,
        deleted: false,
        editLoading: false,
        editMessage: '',
        isPinned: false,
        editErrors: {}
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.entry && nextProps.entry.version !== prevState.version) {
            let newState = {
                ...nextProps.entry,
                loaded: true
            };
            if(nextProps.entry.message !== prevState.editMessage && !prevState.editing) {
                newState.editMessage = nextProps.entry.message;
            }
            return newState;
        }
        return null;
    }

    deleteEntry = () => {
        this.setState({deleted: true});
        LogbookApi.deleteEntry(this.state.id);
    };

    editEntry = (e) => {
        e.preventDefault();
        this.setState({editLoading: true, editErrors: {}});
        LogbookApi.editEntry(this.state.id, {
            type: 'INFO',
            message: this.state.editMessage
        }).then((result) => {
            if (result.data.success === true) {
                this.setState({
                    message: this.state.editMessage,
                    editLoading: false,
                    editing: false
                });
            } else {
                this.setState({
                    editErrors: result.data.errors,
                    editLoading: false
                });
            }
        });
    };

    handleBookmarkLogbookEntry = (id, isPinned) => {
        if (!id) {
            return;
        }
        LogbookApi.bookmarkEntry(id, {
            isPinned: !isPinned
        }).then((result) => {
            if (result.data.data.success === true) {
                this.setState({
                    isPinned: !isPinned
                });
            }
        });
    }

    render() {
        const {authorization, t} = this.props;
        return !this.state.deleted ? (
            <div className="entry" style={{whiteSpace: 'pre-wrap'}}>
                {this.state.loaded ? (
                    this.state.editing ? (
                        <Fragment>
                            <form onSubmit={this.editEntry}>
                                <div
                                    className={"form-group" + ((this.state.editErrors && this.state.editErrors.message) ? ' has-error' : '')}>
                                    <label>
                                        {t('logbook.entry.message')}
                                    </label>
                                    <textarea className="form-control" value={this.state.editMessage}
                                              onChange={(e) => this.setState({editMessage: e.target.value})}
                                              disabled={this.state.loading}/>
                                    {(this.state.editErrors && this.state.editErrors.message) ? (
                                        <span className="help-block">
                                                {t('logbook.message.error.' + this.state.editErrors.message)}
                            </span>
                                    ) : null}
                                </div>
                                <div className="button-container text-right">
                                    <div className="btn-group">
                                        <button type="cancel" className="btn btn-sm btn-default"
                                                disabled={this.state.editLoading} onClick={() => this.setState({
                                            editErrors: {},
                                            editMessage: this.state.message,
                                            editing: false
                                        })}>
                                            <i className="fa fa-close m-r-xs"/>{t('default.cancel')}
                                        </button>
                                        <button type="submit" className="btn btn-sm btn-primary"
                                                disabled={this.state.editLoading}>
                                            <i className={`fa fa-${this.state.editLoading ? 'spin fa-spinner' : 'save'} m-r-xs`}/> {t('default.save')}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <div className="menu-container pull-right text-right">
                                <small className="text-muted block">
                                    {this.state.createdBy.username}, {moment(this.state.createdAt).format('DD.MM.YYYY HH:mm')}
                                    <div className="pull-right btn-group btn-group-xs m-l-xs">
                                        <button className={"btn btn-" + (this.state.isPinned ? 'info' : 'default')} value={this.state.id} onClick={() => this.handleBookmarkLogbookEntry(this.state.id, this.state.isPinned)}>
                                            <i className="fa fa-bookmark" />
                                        </button>
                                    </div>
                                </small>
                                {this.state.createdBy.username === authorization.username ? (
                                    <Fragment>
                                        <button className="btn btn-xs no-borders btn-outline btn-primary" type="default"
                                                onClick={() => this.setState({editing: true})}>
                                            <i className="fa fa-pencil"/>
                                        </button>
                                        <button className="btn btn-xs no-borders btn-outline btn-danger" type="default"
                                                onClick={() => this.setState({startDelete: true})}>
                                            <i className="fa fa-trash"/>
                                        </button>
                                    </Fragment>
                                ) : null}
                            </div>
                            {reactStringReplace(this.state.message, /#(\w+)/g, (match, i) => (
                                <span className="hashtag" key={match + i} onClick={() => this.props.setSearchInformation(`#${match}`)}>#{match}</span>
                            ))}
                            {this.state.startDelete ? (
                                <div className="m-t-md">
                                    <div className="text-danger">
                                        {t('logbook.information.reallyDelete')}
                                    </div>
                                    <div className="btn-group m-t-xs">
                                        <button type="cancel" className="btn btn-default btn-xs"
                                                onClick={() => this.setState({startDelete: false})}>
                                            <i className="fa fa-close m-r-xs"/>
                                            {t('default.cancel')}
                                        </button>
                                        <button type="default" className="btn btn-danger btn-xs"
                                                onClick={this.deleteEntry}>
                                            <i className="fa fa-trash m-r-xs"/>
                                            {t('default.delete')}
                                        </button>
                                    </div>
                                </div>
                            ) : null}
                        </Fragment>
                    )
                ) : null}
                <Comments comments={this.state.comments} entryId={this.state.id} key={`c-${this.state.id}`} setSearchInformation={this.props.setSearchInformation}/>
                <div className="clear"/>
            </div>
        ) : null
    }
}

const mapStateToProps = state => ({
    logbook: state.logbook,
    authorization: state.authorization
});

export default connect(mapStateToProps, {
    load
})(translate()(Information));
